import React from 'react';
import { Link } from 'react-router-dom';
import { FiGrid } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="landing-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="brand-logo" style={{ marginBottom: '1rem' }}>
              <div className="brand-badge">
                <FiGrid />
              </div>
              <span>Digital Business Kit</span>
            </div>
            <p style={{ color: '#94A3B8', fontSize: '0.9rem', maxWidth: '300px' }}>
              Empowering small businesses to build their digital presence, catalogues, visiting cards, and QR codes in minutes without code.
            </p>
          </div>

          <div>
            <h4 className="footer-col-title">Product</h4>
            <ul className="footer-links">
              <li><a href="#features" className="footer-link">Features</a></li>
              <li><a href="#pricing" className="footer-link">Pricing</a></li>
              <li><a href="#how-it-works" className="footer-link">How It Works</a></li>
              <li><Link to="/login" className="footer-link">Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-col-title">Solutions</h4>
            <ul className="footer-links">
              <li><span className="footer-link">Digital Visiting Card</span></li>
              <li><span className="footer-link">Product Catalogue</span></li>
              <li><span className="footer-link">QR Code Generator</span></li>
              <li><span className="footer-link">Enquiry System</span></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-col-title">Legal & Contact</h4>
            <ul className="footer-links">
              <li><span className="footer-link">Privacy Policy</span></li>
              <li><span className="footer-link">Terms of Service</span></li>
              <li><span className="footer-link">support@digitalkit.com</span></li>
              <li><span className="footer-link">+91 9876543210</span></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          &copy; {new Date().getFullYear()} Digital Business Kit. All rights reserved. Built for small businesses worldwide.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
